import { TFunction } from 'i18next'

export enum ValidationMessagesEnum {
  defaultMessage = 'defaultMessage',
  accountNumber = 'accountNumber',
  RoutingNumber = 'RoutingNumber',
  bankAccountNumber = 'bankAccountNumber',
  confirmBankAccountNumber = 'confirmBankAccountNumber',
}

export interface ValidationMessageConfig {
  field: ValidationMessagesEnum
  message: string
}

export const getPaymentValidationMessagesConfig = (
  t: TFunction
): ValidationMessageConfig[] => [
  {
    field: ValidationMessagesEnum.defaultMessage,
    message: t(
      'PaymentModal.EnterPaymentInformation.Error.Blocking.Invalid.Routing.Number',
      'The ACH routing number provider encountered an error processing your payment. Please enter a valid routing number.'
    ),
  },
  {
    field: ValidationMessagesEnum.accountNumber,
    message: t(
      'PaymentModal.EnterPaymentInformation.Error.Blocking.Accounts.Not.Match',
      'The ACH payment provider encountered an error processing your payment. Please enter the same ach account twice.'
    ),
  },
  {
    field: ValidationMessagesEnum.RoutingNumber,
    message: t(
      'PaymentModal.ValidationMessage.MustBeValidRoutingNumber',
      'Routing Number must be a valid Routing number.'
    ),
  },
  {
    field: ValidationMessagesEnum.bankAccountNumber,
    message: t(
      'PaymentModal.ValidationMessage.BankAccountMustMatch',
      'Accounts must match.'
    ),
  },
  {
    field: ValidationMessagesEnum.confirmBankAccountNumber,
    message: t(
      'PaymentModal.ValidationMessage.BankAccountConfirmMustMatch',
      'Accounts must match.'
    ),
  },
]
